const storage: Record<string, string> = {};

export function setItem(key: string, value: string) {
    storage[key] = value || '';
}

export function getItem(key: string) {
    return key in storage ? storage[key] : null;
}

export function removeItem(key: string) {
    delete storage[key];
}
